export default "__VITE_ASSET__C3KYVWpj__"